import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import Modal from '@/components/Modals/Modal';

interface CreateOrderModalProps {
  isOpen: boolean;
  onClose: () => void;
  createOrder: () => void;
  cost: number;
}

const CreateOrderModal = ({ isOpen, onClose, createOrder, cost }: CreateOrderModalProps) => {
  const theme = useTheme();
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="¿Deseas generar la orden con 99minutos?"
        actions={
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: { xxs: 'column', md: 'row' },
              justifyContent: 'space-around',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            <Button
              sx={{ width: '166px' }}
              variant="contained"
              onClick={() => {
                createOrder();
                onClose();
              }}
            >
              Generar orden
            </Button>
            <Button
              sx={{ backgroundColor: theme.palette.dalia.main, width: '122px' }}
              variant="contained"
              onClick={() => {
                onClose();
              }}
            >
              Cancelar
            </Button>
          </Box>
        }
      >
        <Typography
          variant="body1"
          sx={{ padding: '1rem', color: theme.palette.grey[500], textAlign: 'center' }}
        >
          El costo total del envío es de : ${cost}
        </Typography>
      </Modal>
    </>
  );
};

export default CreateOrderModal;
